<template>
  <LinkButton
    v-if="isInKompaliste"
    text
    tag="a"
    :href="compaListLink"
    class="kompaliste-link"
  >
    Weitere Informationen zur Kompatibilität
    <Arrow
      direction="right"
      class="kompaliste-link__icon"
      tag="span"
    />
  </LinkButton>
</template>

<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { useOfferStore } from '~/stores/offers';
import { LinkButton, Arrow } from '@i22/td-longtail-vue-components';

const props = defineProps({
  eans: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});

const offerStore = useOfferStore();

const isInKompaliste = computed(() => offerStore.compaEanList?.includes(props.eans?.[0]));

const compaListLink = computed(() => {
  const baseUrl = 'https://www.telekom.de/smarte-produkte/smart-home/kompatible-geraete';
  if (props.eans.length === 0) {
    return baseUrl;
  }

  return `${baseUrl}?ean=${encodeURIComponent(props.eans[0])}`;
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.kompaliste-link {
  display: flex;
  align-items: center;
  gap: 0.5 * $grid-base;
  margin-block: 2 * $grid-base;
  --arrow-position: relative;
  --arrow-width: 0.7em;
  --arrow-height: 0.5em;
}
</style>
